import { render } from "./BusSchedulePage.vue?vue&type=template&id=f4fc84d2&scoped=true"
import script from "./BusSchedulePage.vue?vue&type=script&lang=js"
export * from "./BusSchedulePage.vue?vue&type=script&lang=js"

import "./BusSchedulePage.vue?vue&type=style&index=0&id=f4fc84d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4fc84d2"]])

export default __exports__